<template>
    <div grey-back full-height class="display_wrapper">
        <dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>

        <dialog-form ref="ref_dialogForm" :closeDialog="fn_closeDialogForm"></dialog-form>
        <dialog-number-series ref="ref_dialogNumberSeries" :checkTransactionNumber="fn_checkTransactionNumber"></dialog-number-series>
        <!-- <dialog-product ref="ref_dialogProduct"></dialog-product> -->
        <dialog-select-batch ref="ref_dialogSelectBatch" :appendBatches="fn_appendBatches" :pid="Form.productData.productId" :productData="Form.productData" :openDatePicker="fn_openDatePicker" :formType="productType=='materials' ? 'outward' : 'inward'" v-if="Form.productData"></dialog-select-batch>
        <dialog-datepicker-batch ref="ref_dialogDatePickerBatch" :selected="selectedDate" :updateDate="fn_updateBatchDate"></dialog-datepicker-batch>
        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="confirmationAction" okBtnText="Yes" cancelBtnText="No" :displayView="true" :params="confirmationActionParam"></dialog-confirmation>
    </div>
</template>

<script>
const transactionData = require('../../datamodel').data.transactionData;
import dialogDatePicker from '../../../dialogs/dialog_datepicker'
import dialogForm from './dialogs/dialog_form'
// import dialogProduct from './dialogs/dialog_product'
import {transactionMixin} from '../../transaction_mixin'

import dialogNumberSeries from '../dialogs/dialog_number_series_manual'
import dialogSelectBatch from '../dialogs/dialog_select_batch'
import dialogDatepickerBatch from '../../../dialogs/dialog_datepicker_batch'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'

import {draftMixin} from '../../../draft_mixin'

    export default{
        props:['settings'],
        mixins: [transactionMixin, draftMixin],
        data(){
            return{

                Form:{
                    "transactionData":JSON.parse(JSON.stringify(transactionData)),
                    "selectedProduct":null,
                    "qty":null,
                    "summaryArray":[],
                    "transactionProducts":[],
                    "productData":null,
                    "transactionAddOns":[],
                    "addOnsProp":{},
                    "addOnsDataModel": {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":null, "type":null},
                    "amount":null,
                    "selectedBatchType":1,
					"batches":[],
					"isNew":true,
					"productBatches":null,
                    "finishedGoodBatchType":1,
                    "numberSeriesData":null
                },
                productData:null,
                summaryArray:null,
                loading:false,
                tagId:null,
                draftStorageId:null,
                dialogStorageId:null,
                backButtonPress: false,
                // unwatch:false,
                disabledBtn:false,
                hasOnlySeries:true,
                hasSeries:false,
                selectedDate:null,
                dateType:null,
                charges:null,
                chargesMenu:false,
                productType:null,
                selectedItemIndex:null,
                transactionNumberSnackbar:false,
            }
        },
        components:{
            'dialog-datepicker':dialogDatePicker,
            'dialog-form': dialogForm,
            'dialog-select-batch':dialogSelectBatch,
            'dialog-datepicker-batch':dialogDatepickerBatch,
            'dialog-number-series': dialogNumberSeries,
            'dialog-confirmation':dialogConfirmation,
            // 'dialog-product':dialogProduct
        },
        watch:{
            'Form': {
                handler: function (){
                    if(!this.unwatch){
                        this.fn_saveDraft(this.draftStorageId, this.Form.selectedProduct?.itemName);
                    }
                    this.unwatch = false;
                },
                deep: true
            }
        },
        methods:{

            fn_openDatePicker: function (type, date) {
                this.dateType = type;
                this.selectedDate = date ? date : this.$root.fn_getLocalDateFormat();
                if(type=='transactionDate'){
                    this.$refs['ref_dialogDatePicker'].openDialogWeb();
                    this.$refs['ref_dialogDatePicker'].disableBtn = false;
                }
                else{
                    this.$refs['ref_dialogDatePickerBatch'].openDialogWeb();
                    this.$refs['ref_dialogDatePickerBatch'].disableBtn = false;
                }
            },

            fn_addProduct: function(){
                this.Form.selectedProduct = null;
                this.Form.qty = null;
                this.Form.productData = null;
                this.Form.summaryArray = [];
                this.$refs['ref_dialogProduct'].openDialogWeb();
            },

            fn_updateBatchDate: function (value) {
                this.$refs['ref_dialogSelectBatch'].fn_updateDate(value, this.dateType);
                this.$refs['ref_dialogDatePickerBatch'].closeDialogWeb();
            },

            fn_closeDialogForm: function(){
                this.$refs['ref_dialogForm'].closeDialogWeb();
                setTimeout(()=>{
                    this.fn_goBack();
                })
            },

            // fn_openDatePicker: function (type, date) {
            //     let self = this;
            //     this.selectedDate = date;
            //     setTimeout(function () {
            //       self.$refs['ref_dialogDatePicker'].openDialogWeb();
            //     })
            // },

            fn_updateDate: function (value) {
                // this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
                // this.$refs['ref_dialogDatePicker'].closeDialogWeb();
                this.fn_updateTransactionDate(value, this.Form.isNew);
            },

            fn_getSummary: function (itemId) {
                var self = this;
                this.getData('ProductSummary', itemId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.Form.summaryArray = JSON.parse(response);
                        }, 
                        onError: function(error){
                          console.log(error);
                        }
                    }
                );
            },

            fn_getProductData: function (itemId, isEdit) {
                var self = this;
                this.getData('Product', itemId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.Form.productData = JSON.parse(response);

                            if(!isEdit){
                                self.Form.productBatches = null;
                                self.Form.transactionProducts = null;
                            }

                            if(self.Form.productData && (!self.Form.productData.bomProducts ||  (self.Form.productData.bomProducts && !self.Form.productData.bomProducts.length))){
                                self.Form.productData = null;
                                self.Form.selectedProduct = null;
                                self.$eventHub.$emit('snackbarAlert', {msg:'Select a finished good item'});
                            }

                            if(self.Form.productData.groupTypeId==101){
								self.fn_getBatches(self.Form.productData.productId);
							}

                            if(!isEdit){
                                for(let i=0; i<self.Form.productData.bomProducts.length; i++){
                                    // !self.Form.productData.bomProducts[i].rate ? self.Form.productData.bomProducts[i].rate = 0 : '';
                                    if(self.Form.productData.bomProducts[i].purchaseRate){
                                        self.Form.productData.bomProducts[i].rate = self.Form.productData.bomProducts[i].purchaseRate;
                                    }
                                    else{
                                        self.Form.productData.bomProducts[i].rate = 0
                                    }

                                    self.$set(self.Form.productData.bomProducts[i], 'selectedBatchType', self.Form.selectedBatchType);
                                    self.$set(self.Form.productData.bomProducts[i], 'qtyNotMatched', false);

                                    // self.Form.productData.bomProducts[i].selectedBatchType = self.Form.selectedBatchType;
                                }
                                self.Form.transactionProducts = self.Form.productData.bomProducts;
                            }
                            else{
                                for(let i=0; i<self.Form.productData.bomProducts.length; i++){
                                    for(let j=0; j<self.Form.transactionProducts.length; j++){
                                        if(self.Form.transactionProducts[j].productId == self.Form.productData.bomProducts[i].productId){
                                            self.Form.transactionProducts[j].qty = self.Form.productData.bomProducts[i].qty;
                                        }
                                    }
                                }
                            }

                            if(self.Form.qty){
                                self.fn_calculateBomProductsAmount();
                            }
                              
                            self.fn_getSummary(itemId);
                            
                        }, 
                        onError: function(error){
                          console.log(error);
                        }
                    }
                );
            },

            fn_calculateBomProductsAmount: function(){
                this.Form.amount= 0;
                for(let i=0; i<this.Form.transactionProducts.length; i++){
                    this.Form.transactionProducts[i].qtySum = this.roundUpto2Decimals(this.Form.transactionProducts[i].qty * this.Form.qty);
                    this.Form.transactionProducts[i].amount = this.roundUpto2Decimals(this.Form.transactionProducts[i].qtySum * this.Form.transactionProducts[i].rate);
                    let itemAmount = this.Form.transactionProducts[i].amount ? Number(this.Form.transactionProducts[i].amount) : 0;
                    this.Form.amount = this.roundUpto2Decimals(this.Form.amount + itemAmount);
                }
            },


            fn_getBatches: function(productId, itemIndex, addedBatches){
				let self = this;
				this.getData('GetProductBatchByProductId', productId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.$set(self.Form, 'batches', JSON.parse(response));

							if(addedBatches && addedBatches.length){
								for(let i=0; i<addedBatches.length; i++){
									let bIndex = self.Form.batches.findIndex(bItem=>{return bItem.batchId == addedBatches[i].batchId});
									if(bIndex == -1){
										self.Form.batches.push(addedBatches[i]);
									}
								}
							}

							if(itemIndex != undefined){
								self.fn_openDialogMaterialsSelectBatch(itemIndex);
							}
							
							// if(self.$parent.Form.Form.productData.batches && self.$parent.Form.Form.productData.batches.length){
							// 	self.$parent.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
							// }
						}, 
						onError: function(error){
							console.log(error);
						}
					}
				);
			},
			fn_openDialogMaterialsSelectBatch: function(itemIndex){
				this.productType = 'materials';
				this.selectedItemIndex = itemIndex;
                this.Form.selectedBatchType = this.Form.transactionProducts[itemIndex].selectedBatchType;
				if(this.Form.transactionProducts[itemIndex].batches && this.Form.transactionProducts[itemIndex].batches.length){
					for(let i=0; i<this.Form.batches.length; i++){
						this.Form.batches[i].productQty = null;
						this.Form.batches[i].selected = false;
						for(let j=0; j<this.Form.transactionProducts[itemIndex].batches.length; j++){
							if(this.Form.transactionProducts[itemIndex].batches[j].batchId == this.Form.batches[i].batchId){
								if(this.Form.transactionProducts[itemIndex].batches[j].productQty){
									this.Form.batches[i].selected = true;
									this.Form.batches[i].productQty = this.Form.transactionProducts[itemIndex].batches[j].productQty;
								}
							}
						}
					}
				}
                this.$refs['ref_dialogSelectBatch'].openDialogWeb();
			},
			fn_openDialogSelectBatch: function(){
				this.productType = 'finishedGood';
                this.Form.selectedBatchType = this.Form.finishedGoodBatchType;
                
                for(let i=0; i<this.Form.batches.length; i++){
                    this.Form.batches[i].selected = false;
                    this.Form.batches[i].productQty = null;
                }

				if(this.Form.productBatches && this.Form.productBatches.length){
					for(let i=0; i<this.Form.batches.length; i++){
						this.Form.batches[i].productQty = null;
						this.Form.batches[i].selected = false;
						for(let j=0; j<this.Form.productBatches.length; j++){
							if(this.Form.productBatches[j].batchId == this.Form.batches[i].batchId){
								if(this.Form.productBatches[j].productQty){
									this.Form.batches[i].selected = true;
									this.Form.batches[i].productQty = this.Form.productBatches[j].productQty;
								}
							}
						}
					}
				}
				this.$refs['ref_dialogSelectBatch'].openDialogWeb();
			},

            fn_getData: function (itemId) {
                let self = this;
                this.Form.isNew = false;
                this.getData('GetBOM', itemId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let data = JSON.parse(response);
                            self.fn_bindData(data);
                        }, 
                        onError: function(error){
                          console.log(error);
                        }
                    }
                );
            },

            fn_bindData: function (data) {
                this.Form.transactionData.additionalData = data.additionalData;
                this.Form.transactionData.amount = data.amount;
                this.Form.transactionData.businessId = data.businessId;
                this.Form.transactionData.createdBy = data.createdBy;
                this.Form.transactionData.createdDate = data.createdDate;
                this.Form.transactionData.currencyId = data.currencyId;
                this.Form.transactionData.dueDate = data.dueDate;
                this.Form.transactionData.dueType = data.dueType;
                this.Form.transactionData.modifiedBy = data.modifiedBy;
                this.Form.transactionData.modifiedDate = data.modifiedDate;
                this.Form.transactionData.notes = data.notes;
                this.Form.transactionData.partyId = data.partyId;
                this.Form.transactionData.paymentMode = data.paymentMode;
                this.Form.transactionData.prefix = data.prefix;
                this.Form.transactionData.refDate = data.refDate;
                this.Form.transactionData.refNumber = data.refNumber;
                this.Form.transactionData.roundedAmount = data.roundedAmount;
                this.Form.transactionData.salesmanId = data.salesmanId;
                this.Form.transactionData.status = data.status;
                this.Form.transactionData.suffix = data.suffix;
                this.Form.transactionData.transactionDate = data.transactionDate;
                this.Form.transactionData.transactionId = data.transactionId;
                this.Form.transactionData.transactionListId = data.transactionListId;
                this.Form.transactionData.transactionNumber = data.transactionNumber;
                this.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
                this.Form.transactionProducts = [];
                for(let i=0; i<data.transactionProducts.length; i++){
                    let itemIndex  = this.Form.transactionProducts.findIndex(item=>{return item.productId == data.transactionProducts[i].productId})
                    if(itemIndex==-1){
						data.transactionProducts[i].rate = data.transactionProducts[i].productVariants[0].rate;
                        // data.transactionProducts[i].qty = data.transactionProducts[i].productVariants[0].qty;
                        data.transactionProducts[i].unitId = data.transactionProducts[i].productVariants[0].unitId;
                        data.transactionProducts[i].unitName = data.transactionProducts[i].productVariants[0].unitName;
                        data.transactionProducts[i].productVariantId = data.transactionProducts[i].productVariants[0].productVariantId;
                        data.transactionProducts[i].primaryUnitId = data.transactionProducts[i].productVariants[0].primaryUnitId;
                        data.transactionProducts[i].secondaryUnitId = data.transactionProducts[i].productVariants[0].secondaryUnitId;
                        data.transactionProducts[i].packQuantity = data.transactionProducts[i].productVariants[0].packQuantity;
                        data.transactionProducts[i].secondaryUnitPackQuantity = data.transactionProducts[i].productVariants[0].secondaryUnitPackQuantity;
                        
						data.transactionProducts[i].batches = [];

						if(data.transactionProducts[i].transactionProductBatches && data.transactionProducts[i].transactionProductBatches.length){
							for(let j=0; j<data.transactionProducts[i].transactionProductBatches.length; j++){
								data.transactionProducts[i].transactionProductBatches[j].productQty = data.transactionProducts[i].transactionProductBatches[j].qty;
								data.transactionProducts[i].batches.push(data.transactionProducts[i].transactionProductBatches[j]);
							}
						}

						this.Form.transactionProducts.push(data.transactionProducts[i]);
                    }
                }

                this.Form.transactionAddOns = [];

                if(data.transactionAddOns && data.transactionAddOns.length){
                    let self = this;
                    data.transactionAddOns.forEach(function (item) {

                        item.mode == 1 ? item.percentage = null : '';

                        let addOnsItem = JSON.parse(JSON.stringify(item));
                        
                        self.Form.transactionAddOns.push(addOnsItem);

                    });

                }

                let finishedGoodProductIndex = this.Form.transactionProducts.findIndex(item=>{return item.finishedGoodProductId });

                this.Form.qty = this.Form.transactionProducts[finishedGoodProductIndex].productVariants[0].qty;
                this.Form.productBatches = this.Form.transactionProducts[finishedGoodProductIndex].transactionProductBatches;
                // this.fn_updateProduct(this.Form.transactionProducts[finishedGoodProductIndex].productId, this.Form.transactionProducts[finishedGoodProductIndex].productName, true);
                this.Form.selectedProduct = {itemId:this.Form.transactionProducts[finishedGoodProductIndex].productId, itemName:this.Form.transactionProducts[finishedGoodProductIndex].productName};
                this.fn_getProductData(this.Form.selectedProduct.itemId, true);
                this.Form.transactionProducts.splice(finishedGoodProductIndex, 1);
                
            },

            fn_checkValidations: function(){
                this.disabledBtn = true;
                this.fn_checkTransactionNumber(()=>{
                    this.fn_post();
                });
                
                // this.showLoading('Please Wait...');
                // this.$validator.validateAll().then((result) => {
             //        if (result) {
             //         this.fn_post();
             //     }
             //     else{
             //         this.disabledBtn = false;
             //         this.hideLoading();
             //     }
             //    });
            },

            fn_saveLocal: function(dataObj){
                var self = this;
                this.postData('PostBOM', dataObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            // self.hideLoading();
                            setTimeout(()=>{
                                self.$eventHub.$emit('UpdateBillList', {}); 
                            },100);

                            //  let adjustmentType = self.type == 'minus' ? 'stock_reduced' : 'stock_added'; 
                            
                            // // posting metrics on save
                            // let postObj = {"eventName":'stock_adjustment_save',"eventData":[{"eventKey":"adjust_type","eventValue":adjustmentType}]}
                              
                            // let saveObj = {};
                            // saveObj.eventKey = "transaction_save";
                            // saveObj.eventValue = adjustmentType;
                            // postObj.eventData.push(saveObj);
                            
                            // self.$root.fn_postMetrics(postObj);

                            // self.fn_goBack();
                            self.fn_previewInvoice(false, "inventory", 'bm', null);
                        },
                        onError: function(error){
                            console.log(error);
                            self.saveBtnKey++;
                            // self.hideLoading();
                            let response = JSON.parse(error);
                            if(response && response.negativeProducts && response.negativeProducts.length){
                                self.fn_shortListInvalidItems(response.negativeProducts);
                            }
                        }
                    }
                );
            },

            fn_post: function(){

                for(let i=0; i<this.Form.transactionProducts.length; i++){
					let item = this.Form.transactionProducts[i];
					if(item.batches && item.batches.length){
						if(this.fn_checkBatchQty(item)){
							this.disabledBtn = false;
							// this.hideLoading();
							// this.showToast("Check batches as qty not matched");
                            this.$eventHub.$emit('snackbarAlert', {msg:'Check batches as qty not matched'});
							return;
						}
					}
				}

                //only in case of new transaction
                if(!this.Form.transactionData.transactionId){
                    this.Form.transactionData.transactionId = this.guid();
                    // this.Form.transactionData.createdDate = new Date();
                    this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
                    this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
                }

                // this.Form.transactionData.modifiedDate = new Date();
                this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat();

                this.Form.transactionData.amount = this.totalAmount;
                this.Form.transactionData.roundedAmount = this.totalAmount;
                this.Form.transactionData.status = 1;
                this.Form.transactionData.transactionTypeFormId = this.Form.transactionTypeFormId;
                this.Form.transactionData.refDate = null;

                // this.Form.transactionData.fromGodownId = this.Form.fromGodownId;
                // this.Form.transactionData.toGodownId = this.Form.toGodownId;

                // this.Form.transactionProducts = [];

                let postObj = {};

                postObj = this.Form.transactionData;
                postObj.transactionAddOns = [];

                postObj.masterProductBatches = [];
				postObj.transactionProductBatches = [];
                
                let transactionProducts = [];

                // pushing for finished good product
                let tpObj = {};
                tpObj.transactionProductId = this.guid();
                tpObj.transactionId = this.Form.transactionData.transactionId;
                tpObj.productId = this.Form.selectedProduct.itemId;
                tpObj.productVariantId = this.Form.productData.productVariants[0].productVariantId;
                tpObj.groupId = this.guid();
                tpObj.mrp = this.Form.productData.mrp;
                tpObj.rate = this.totalAmount / this.Form.qty;
                tpObj.additionalData = null;
                tpObj.unitId = this.Form.productData.productVariants[0].unitId;
                tpObj.primaryUnitId = this.Form.productData.productVariants[0].primaryUnitId ? this.Form.productData.productVariants[0].primaryUnitId : this.Form.productData.productVariants[0].unitId;
                tpObj.stockInventory = true;
                if(this.Form.productData.productVariants[0].secondaryUnitId){
                    tpObj.secondaryUnitId = this.Form.productData.productVariants[0].secondaryUnitId	
                }

                if(this.Form.productData.productVariants[0].secondaryUnitPackQuantity){
                    tpObj.secondaryUnitPackQuantity = this.Form.productData.productVariants[0].secondaryUnitPackQuantity;	
                }

                tpObj.qty = this.Form.qty;
                tpObj.packQuantity = this.Form.productData.productVariants[0].packQuantity ? this.Form.productData.productVariants[0].packQuantity : 1;
                tpObj.amount = this.totalAmount;
                tpObj.netAmount = this.totalAmount;
                tpObj.taxableValue = this.totalAmount;

                tpObj.transactionProductMode = 1;
                tpObj.actualQty = this.Form.qty;
                tpObj.finishedGoodProductId = this.Form.selectedProduct.itemId;
                tpObj.selectedBatchType = 1;

                tpObj.batches = this.Form.productBatches;

                if(this.Form.productBatches && this.Form.productBatches.length){
					//adding batches to transaction
					let item = tpObj;
					for(let i=0; i<item.batches.length; i++){
						let obj = {};
						obj.productId = tpObj.productId;
						obj.transactionProductBatchId = !this.Form.isNew && item.batches[i].transactionProductBatchId ? item.batches[i].transactionProductBatchId : this.guid();
						obj.batchId = item.batches[i].batchId;
						obj.transactionProductId = tpObj.transactionProductId;
						obj.qty = item.batches[i].productQty;
						obj.orderNumber = i + 1;
						obj.transactionId = this.Form.transactionData.transactionId;
						obj.transactionListId = this.Form.transactionData.transactionListId;

						// if(tpObj.refTId){
						// 	obj.refTId = tpObj.refTId;
						// 	if(item.baseTransactionListId != transactionTypes.order.id){
						// 		if(item.batches[i].refTpBatchId){
						// 			obj.refTpBatchId = item.batches[i].refTpBatchId;
						// 		}
						// 		else if(item.batches[i].refTransactionProductBatchId){
						// 			obj.refTpBatchId = item.batches[i].refTransactionProductBatchId;
						// 		}
						// 		else{
						// 			obj.refTpBatchId = item.batches[i].transactionProductBatchId;
						// 		}
						// 	}
						// }

						obj.actualQty = item.batches[i].productQty;

						// if(item.productVariants[0].selectedUnit && item.productVariants[0].selectedUnit.itemId != item.productVariants[0].primaryUnitId){
						// 	obj.actualQty = self.roundUpto5Decimals((obj.actualQty * item.productVariants[0].packQuantity) /item.productVariants[0].secondaryUnitPackQuantity);
						// }

						postObj.transactionProductBatches.push(obj);

						if(item.batches[i].isNew){
							delete item.batches[i].isNew;
							item.batches[i].productId = tpObj.productId;
							item.batches[i].orderNumber = 1;
							postObj.masterProductBatches.push(item.batches[i]);
						}
					}
				}

                transactionProducts.push(tpObj);

                postObj.transactionProducts = transactionProducts;

                for(let i=0; i<this.Form.transactionProducts.length; i++){
                    let tpObj = {};
                    tpObj.transactionProductId = this.guid();
                    tpObj.transactionId = this.Form.transactionData.transactionId;
                    tpObj.productId = this.Form.transactionProducts[i].productId;
                    tpObj.productVariantId = this.Form.transactionProducts[i].productVariantId;
                    tpObj.groupId = this.guid();
                    tpObj.mrp = this.Form.transactionProducts[i].mrp;
                    tpObj.rate = this.Form.transactionProducts[i].rate;
                    tpObj.additionalData = null;
                    tpObj.unitId = this.Form.transactionProducts[i].unitId;
                    tpObj.primaryUnitId = this.Form.transactionProducts[i].primaryUnitId ? this.Form.transactionProducts[i].primaryUnitId : this.Form.transactionProducts[i].unitId;
                    tpObj.stockInventory = true;

                    tpObj.selectedBatchType = this.Form.transactionProducts[i].selectedBatchType;

                    tpObj.batches = this.Form.transactionProducts[i].batches;

                    if(this.Form.transactionProducts[i].secondaryUnitId){
                        tpObj.secondaryUnitId = this.Form.transactionProducts[i].secondaryUnitId	
                    }

                    if(this.Form.transactionProducts[i].secondaryUnitPackQuantity){
                        tpObj.secondaryUnitPackQuantity = this.Form.transactionProducts[i].secondaryUnitPackQuantity;	
                    }

                    tpObj.qty = this.Form.transactionProducts[i].qtySum;
                    tpObj.packQuantity = this.Form.transactionProducts[i].packQuantity ? this.Form.transactionProducts[i].packQuantity : 1;
                    tpObj.amount = this.Form.transactionProducts[i].amount;
                    tpObj.netAmount = this.Form.transactionProducts[i].amount;
                    tpObj.taxableValue = this.Form.transactionProducts[i].amount;

                    tpObj.transactionProductMode = 1;
                    tpObj.actualQty = -this.Form.transactionProducts[i].qtySum;

                    transactionProducts.push(tpObj);

                    if(this.Form.transactionProducts[i].batches && this.Form.transactionProducts[i].batches.length){
						//adding batches to transaction
						let item = this.Form.transactionProducts[i];
						for(let i=0; i<item.batches.length; i++){
							let obj = {};
							obj.productId = tpObj.productId;
							obj.transactionProductBatchId = !this.Form.isNew && item.batches[i].transactionProductBatchId ? item.batches[i].transactionProductBatchId : this.guid();
							obj.batchId = item.batches[i].batchId;
							obj.transactionProductId = tpObj.transactionProductId;
							obj.qty = item.batches[i].productQty;
							obj.orderNumber = i + 1;
							obj.transactionId = this.Form.transactionData.transactionId;
							obj.transactionListId = this.Form.transactionData.transactionListId;

							// if(tpObj.refTId){
							// 	obj.refTId = tpObj.refTId;
							// 	if(item.baseTransactionListId != transactionTypes.order.id){
							// 		if(item.batches[i].refTpBatchId){
							// 			obj.refTpBatchId = item.batches[i].refTpBatchId;
							// 		}
							// 		else if(item.batches[i].refTransactionProductBatchId){
							// 			obj.refTpBatchId = item.batches[i].refTransactionProductBatchId;
							// 		}
							// 		else{
							// 			obj.refTpBatchId = item.batches[i].transactionProductBatchId;
							// 		}
							// 	}
							// }

							obj.actualQty = -item.batches[i].productQty;

							// if(item.productVariants[0].selectedUnit && item.productVariants[0].selectedUnit.itemId != item.productVariants[0].primaryUnitId){
							// 	obj.actualQty = self.roundUpto5Decimals((obj.actualQty * item.productVariants[0].packQuantity) /item.productVariants[0].secondaryUnitPackQuantity);
							// }

							postObj.transactionProductBatches.push(obj);

							if(item.batches[i].isNew){
								delete item.batches[i].isNew;
								item.batches[i].productId = tpObj.productId;
								item.batches[i].orderNumber = 1;
								postObj.masterProductBatches.push(item.batches[i]);
							}
						}
					}
                }
                // process for from godown
                // this.fn_processTransactionProducts('from', transactionProducts);
                // process for to godown
                // this.fn_processTransactionProducts('to', transactionProducts);
                

                // let postObj = {};

                // postObj = this.Form.transactionData;
                // postObj.transactionProducts = transactionProducts;
                // postObj.transactionAddOns = [];

                // postObj.masterProductBatches = [];
				// postObj.transactionProductBatches = [];

                if(this.Form.transactionAddOns.length){

                    this.Form.transactionAddOns.forEach(function (addOnsItem, index) {
                        
                        let addOnsObj = {};

                        if(addOnsItem.value!==null && addOnsItem.value!==''){

                            addOnsObj.transactionAddOnsId = addOnsItem.transactionAddOnsId;
                            addOnsObj.orderNumber = index+1;
                            addOnsObj.addOnsId = addOnsItem.addOnsId;

                            //saving name, nature and mode for display purpose only
                            addOnsObj.addOnsName = addOnsItem.name;
                            addOnsObj.addOnsNature = addOnsItem.nature;
                            addOnsObj.addOnsMode = addOnsItem.mode;

                            addOnsObj.addOnsType = 3;
                            addOnsObj.percentage = null
                            addOnsObj.value = addOnsItem.value;
                            addOnsObj.appliedOn = 0;
                            addOnsObj.adjustInTotal = false;

                            addOnsObj.isDefault = false;

                            addOnsObj.isGst = 0;
                            
                            postObj.transactionAddOns.push(addOnsObj);

                        }

                    })
                }

                postObj.grossAmount = this.Form.amount;
                postObj.netAmount = this.totalAmount;
                postObj.roundedAmount = this.totalAmount;

                postObj.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
                postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');
                
                console.log(this.Form);
                this.fn_saveLocal(postObj);
            },

            fn_processTransactionProducts: function(type, transactionProducts){
                for(let i=0; i<this.Form.transactionProducts.length; i++){
                    let tpObj = {};
                    tpObj.transactionProductId = this.guid();
                    tpObj.transactionId = this.Form.transactionData.transactionId;
                    tpObj.productId = this.Form.transactionProducts[i].productId;
                    tpObj.productVariantId = this.Form.transactionProducts[i].productVariantId;
                    tpObj.groupId = this.guid();
                    tpObj.mrp = null;
                    tpObj.rate = null;
                    tpObj.additionalData = null;
                    tpObj.unitId = this.Form.transactionProducts[i].unitId;
                    tpObj.primaryUnitId = this.Form.transactionProducts[i].primaryUnitId;
                    if(this.Form.transactionProducts[i].secondaryUnitId){
                        tpObj.secondaryUnitId = this.Form.transactionProducts[i].secondaryUnitId	
                    }

                    if(this.Form.transactionProducts[i].secondaryUnitPackQuantity){
                        tpObj.secondaryUnitPackQuantity = this.Form.transactionProducts[i].secondaryUnitPackQuantity;	
                    }

                    tpObj.qty = this.Form.transactionProducts[i].qty;
                    tpObj.packQuantity = this.Form.transactionProducts[i].packQuantity ? this.Form.transactionProducts[i].packQuantity : 1;
                    tpObj.amount = null;
                    tpObj.taxableValue = null

                    if(type == 'from'){
                        tpObj.fromGodownId = this.Form.selectedFromGodown.itemId;
                        tpObj.transactionProductMode = 0;
                        tpObj.actualQty = -this.Form.transactionProducts[i].qty;
                    }
                    else{
                        tpObj.toGodownId = this.Form.selectedToGodown.itemId;
                        tpObj.transactionProductMode = 1;
                        tpObj.actualQty = this.Form.transactionProducts[i].qty;
                    }
                    
                    // tpObj.selectedBatchType = this.Form.selectedBatchType;

                    // if(this.Form.selectedUnit && this.Form.selectedUnit.itemId && this.Form.selectedUnit.itemId != tpObj.primaryUnitId){
                    //     tpObj.actualQty = this.roundUpto5Decimals((tpObj.actualQty * tpObj.packQuantity) / this.Form.productData.productVariants[0].secondaryUnitPackQuantity);
                    // }

                    transactionProducts.push(tpObj);
                }
            },

            // fn_appendBatches: function(batches){
            //     if(batches.length){
            //         this.$set(this.Form, 'productBatches', JSON.parse(JSON.stringify(batches)));
            //         // this.Form.productData.items[0].batches = JSON.parse(JSON.stringify(batches));
            //         let totalQty = 0;
            //         for(let i=0; i<this.Form.productBatches.length; i++){
            //             totalQty += Number(this.Form.productBatches[i].productQty);
            //         }
            //         this.Form.qty = Number(totalQty);

            //         if(this.productData && this.Form.selectedBatchType == 2){
            //             this.Form.selectedUnit = {"itemId":this.productData.productVariants[0].unitId, "itemName":this.productData.productVariants[0].unitName};
            //         }
            //     }
            //     this.$refs['ref_dialogSelectBatch'].closeDialogWeb();
            // },

            fn_appendBatches: function(batches){
				if(this.productType == 'materials'){
					this.fn_appendBatchesMaterials(batches);
				}
				else{
					if(batches.length){
						if(batches.length > 1){
                            this.$eventHub.$emit('snackbarAlert', {msg:'You can only add single batch'});
							return;
						}

						this.$set(this.Form, 'productBatches', JSON.parse(JSON.stringify(batches)));
						let totalQty = 0;

						let bat = null;
						if(this.Form.selectedBatchType == 2){
							bat = batches.filter(field=>{
								return !field.batchNumber && !field.batchMRP && !field.purchaseRate && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4
							})

							if(this.Form.productData){
								if(this.Form.productData.productVariants[0].selectedUnit){
									this.Form.productData.productVariants[0].selectedUnit = {"itemId":this.Form.productData.productVariants[0].primaryUnitId, "itemName":this.Form.productData.productVariants[0].primaryUnitName}
								}
							}
						}
						else{
							bat = batches.filter(field=>{
								return !field.field1 && !field.field2 && !field.field3
							})

							if(batches.length == 1 && batches[0].batchMRP){
								if(this.$root.TransactionSettings.mrpWiseStock && this.$root.TransactionSettings.mrpAsSalePrice && this.Form.productData.mrp){
									this.$set(this.Form.productData, 'rate', Number(batches[0].batchMRP));
								}
							}
						}
						
						for(let i=0; i<bat.length; i++){
							totalQty += Number(bat[i].productQty);
						}
						// this.Form.productData.items[0].productVariants[0].qty = Number(totalQty);
						this.$set(this.Form, 'qty', Number(totalQty));
						this.$set(this.Form.productData.productVariants[0], 'qty', Number(totalQty));

                        this.fn_calculateBomProductsAmount();
					}
					this.$refs['ref_dialogSelectBatch'].closeDialogWeb();
				}
			},

			fn_appendBatchesMaterials: function(batches){
				if(batches.length){
					
					// if(this.Form.transactionProducts[this.selectedItemIndex].selectedBatchType == 1){
                    let batchTotalQty = 0;
                    // let batchesOnly = batches.filter(field=>{
                    //     return !field.field1 && !field.field2 && !field.field3
                    // })
                    for(let i=0; i<batches.length; i++){
                        batchTotalQty += Number(batches[i].productQty);
                    }
                    if(batchTotalQty != this.Form.transactionProducts[this.selectedItemIndex].qtySum){
                        this.$eventHub.$emit('snackbarAlert', {msg:"Batch total should be " + this.Form.transactionProducts[this.selectedItemIndex].qtySum});
                        return;
                    }
					// }

					this.$set(this.Form.transactionProducts[this.selectedItemIndex], 'batches', JSON.parse(JSON.stringify(batches)));
					// this.Form.productData.items[0].batches = JSON.parse(JSON.stringify(batches));
					let totalQty = 0;

					let bat = null;
					if(this.Form.selectedBatchType == 2){
						bat = batches.filter(field=>{
							return !field.batchNumber && !field.batchMRP && !field.purchaseRate && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4
						})

						if(this.Form.transactionProducts && this.Form.transactionProducts.length){
							if(this.Form.transactionProducts[this.selectedItemIndex].productVariants[0].selectedUnit){
								this.Form.transactionProducts[this.selectedItemIndex].productVariants[0].selectedUnit = {"itemId":this.Form.transactionProducts[this.selectedItemIndex].productVariants[0].primaryUnitId, "itemName":this.Form.transactionProducts[this.selectedItemIndex].productVariants[0].primaryUnitName}
							}
						}
					}
					else{
						bat = batches.filter(field=>{
							return !field.field1 && !field.field2 && !field.field3
						})

						if(batches.length == 1 && batches[0].batchMRP){
							if(this.$root.TransactionSettings.mrpWiseStock && this.$root.TransactionSettings.mrpAsSalePrice && this.Form.transactionProducts[this.selectedItemIndex].mrp){
								this.$set(this.Form.transactionProducts[this.selectedItemIndex], 'rate', Number(batches[0].batchMRP));
							}
						}
					}
					
					for(let i=0; i<bat.length; i++){
						totalQty += Number(bat[i].productQty);
					}
					this.$set(this.Form.transactionProducts[this.selectedItemIndex].productVariants[0], 'qty', Number(totalQty));
				}
				this.$refs['ref_dialogSelectBatch'].closeDialogWeb();
			},

            fn_fieldVisibilty: function(field, selectedBatchType){
				if(field.status){
					if(selectedBatchType == 2){
						if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
							return true;
						}
						else{
							return false;
						}
					}
					else{
						if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'opening' || field.id == 'field4'){
							return true;
						}
						else{
							return false;
						}
					}
				}
				else{
					return false
				}
			},

            fn_removeBatch: function(){
				this.Form.productBatches.splice(0, 1);
			},

            fn_removeItemBatch: function(item, batchIndex){
				item.batches.splice(batchIndex, 1);
			},

            // fn_removeBatch: function(batchIndex){
            //     this.Form.productBatches.splice(batchIndex, 1);
            //     let totalQty = 0;
            //     for(let i=0; i<this.Form.productBatches.length; i++){
            //         totalQty = totalQty + Number(this.Form.productBatches[i].productQty);
            //     }
            //     this.Form.qty = totalQty ? totalQty : null;
            // },

            fn_showHideBatches: function(field){
                if(this.Form.selectedBatchType == 2 && !field.batchNumber && !field.batchMRP && !field.batchSize && !field.mfgDate && !field.expDate && !field.field4){
                    return true;
                }
                else if(this.Form.selectedBatchType == 1 && !field.field1 && !field.field2 && !field.field3){
                    return true;
                }
                else{
                    return false;
                }
            },

            fn_changeProductQty: function(item){
				if(this.Form.productBatches && this.Form.productBatches.length && this.Form.productBatches.length == 1){
					this.Form.productBatches[0].productQty = item.qty;
				}
			},
			fn_changeBatchQty: function(){
				if(this.Form.productBatches && this.Form.productBatches.length){
					let totalVal = 0;
					for(let i=0; i<this.Form.productBatches.length; i++){
						totalVal += this.Form.productBatches[i].productQty;
					}
					this.Form.qty = Number(totalVal);
				}
			},

            fn_addOns: function(){
                let filterObject = {};
                filterObject.search = '';
                filterObject.addOnType = 3;

                filterObject.startIndex = 0;
                filterObject.limit = 1000;
                
                let self = this;
                this.getDialogItems("AddOnsDialog", filterObject, 
                    {
                    onSuccess: function (response) {
                        console.log(response);
                        // alert(response);
                        self.charges = JSON.parse(response);
                    },
                    onError: function (error) {
                        console.log(error);
                    }
                    }
                    )
                },

            fn_getAddonsData: function(itemId){
              var self = this;
              this.getData('AddOns', itemId, 
                {
                  onSuccess: function(response){
                    console.log(response);
                    let addOnsData = JSON.parse(response);
                    self.fn_saveAddOns(addOnsData);

                    // self.$parent.fn_openDialogAddons ? self.$parent.fn_openDialogAddons() : '';
                  }, 
                  onError: function(error){
                    console.log(error);
                  }
                }
              );
            },

            fn_saveAddOns: function (data) {

                console.log(JSON.stringify(data));

                // this.Form.newSelection = false;
                localStorage.removeItem('newSelection');

                if(data.mode==0 && (data.percentage==null || data.percentage=='')){
                    data.value = null;
                }

                if(!data.isDefault)
                    data.isDefault = false;

                !data.transactionAddOnsId ? data.transactionAddOnsId = this.guid() : '';

                let itemIndex = this.Form.transactionAddOns.findIndex(item=>{
                    return item.transactionAddOnsId == data.transactionAddOnsId || item.addOnsId == data.addOnsId;
                });

                if(itemIndex==-1){
                    this.Form.transactionAddOns.push(data);
                }
                else{
                    this.Form.transactionAddOns.splice(itemIndex, 1, data);
                }

                // this.fn_closeDialog();
            },

            fn_removeAddOns: function(addOnIndex){
                this.Form.transactionAddOns.splice(addOnIndex, 1);
            },

            fn_getNumberSeries: function(){
                var self = this;
                this.getData('NumberSeries', 'a77a627b-fdb5-46f0-b50d-e915e27d1fcf', 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            // let data = JSON.parse(response);
                            self.Form.numberSeriesData = JSON.parse(response);
                            self.fn_bindTransactionNumber();
                        }, 
                        onError: function(error){
                          console.log(error);
                        }
                    }
                );
            },

            fn_bindTransactionNumber: function () {

                let date = new Date();
                let currentMonth = date.getMonth() + 1;
                let currentYear = date.getFullYear();

                let currentFY = currentMonth <= 3 ? (currentYear - 1) : currentYear;

                let currentTransactionNumberData = this.Form.numberSeriesData.transactionNumbers.filter(item=>{
                    return item.fiscalYear == currentFY;
                })

                this.transactionNumberSnackbar = false;


                this.Form.transactionData.prefix = currentTransactionNumberData[0].prefix;
                this.Form.transactionData.suffix = currentTransactionNumberData[0].suffix;

                //For reference use only as incrementing transaction number by numberSeries id in transaction number
                this.Form.transactionData.numberSeriesId = currentTransactionNumberData[0].numberSeriesId;

                let filterObject = {};
                filterObject.numberSeriesId = currentTransactionNumberData[0].numberSeriesId;
                filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));

                let self = this;

                this.getFilterData('TransactionNumber', null, filterObject, null,
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let data = JSON.parse(response);
                            self.Form.transactionData.transactionNumber = Number(data.transactionNumber);
                            self.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
                            self.Form.transactionData.transactionNumberId = data.transactionNumberId;
                        }, 
                        onError: function(error){
                              console.log(error);
                        }
                    }
                );
                
            },

            fn_openDialogNumberSeries: function(){
                this.transactionNumberSnackbar = false;
                this.$refs['ref_dialogNumberSeries'].openDialogWeb();
            },

            fn_checkTransactionNumber: function(callback){
                var self = this;
                let filterObject = {};
                filterObject.mergeTransactionNumber = this.Form.transactionData.mergeTransactionNumber;
                filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
                filterObject.typeId = 40006;
                let transactionId = this.Form.transactionData.transactionId ? this.Form.transactionData.transactionId : null;
                this.getFilterData('CheckTransactionNumber', transactionId, filterObject, null,
                    {
                        onSuccess: function(response){
                            console.log(response);
                            callback ? callback() : '';
                        }, 
                        onError: function(error){
                            self.disableOnSave = false;
                            self.saveBtnKey++;
                            console.log(error);
                            // self.$eventHub.$emit('snackbarAlert', {msg:'Transaction number already exists'});
                            // self.hideLoading();
                            self.transactionNumberSnackbar = true;
                        }
                    }
                );
            },

            fn_checkBatchQty: function(item){
                let totalQty = 0;
                for(let i=0; i<item.batches.length; i++){
                    totalQty = totalQty + item.batches[i].productQty;
                }
                if(totalQty != item.qtySum){
                    item.qtyNotMatched = true;
                    return true;
                }
                else{
                    item.qtyNotMatched = false;
                    return false;
                }
            },

            fn_changeFormBatchType: function(val){
				this.Form.selectedBatchType = val;
			},

			fn_changeBatchType: function(val, item){
                this.$nextTick(() => {
                    this.$set(item, 'selectedBatchType', val);
                })                
				// if(item){
				// 	if(this.Form.selectedUnit){
				// 		this.Form.selectedUnit = {"itemId":this.Form.productData.productVariants[0].unitId, "itemName":this.Form.productData.productVariants[0].unitName}
				// 	}
				// }
			},


            // fn_updateAddons: function(itemId, itemName){
            //     fn_updateAddOns(selectedValueId, selectedValueName, false);
            // },

            fn_menuItemClick: function(menuAction){
				if(menuAction == 'newproduct'){
					this.$router.push({path:'/'+this.$route.params.businessId + '/' + this.$route.params.listId +'/product/items/new', query:{tagId:this.guidWeb(), bm:1, ls:1}});
				}
				else if(menuAction=='addothercharges'){
					this.$router.push({path:'/'+this.$route.params.businessId + '/' + this.$route.params.listId +'/other_charge/items/new', query:{tagId:this.guidWeb(), ls:1}});
				}
            },

            fn_setNewItem: function(){
                let itemData = null;
                if(localStorage.getItem('newItem')){

                    itemData = JSON.parse(localStorage.getItem('newItem'));

                    switch (itemData.type) {
                        case "product":
                            this.Form.selectedProduct = {"itemId":itemData.id, "itemName":itemData.name};
                            this.fn_getProductData(itemData.id);
                            break;
                        case "otherCharges":
                            this.fn_getAddonsData(itemData.id);
                            break;
                            
                        default:
                            console.log("condition not matched");
                    }

                    localStorage.removeItem('newItem');
                }

                if(this.$route.query && this.$route.query.dt && !itemData){
                    this.Form.selectedLedger = {"itemId":this.$route.query.id, "itemName":this.$route.query.name};
                    this.fn_updateAccountLedger();
                }

                this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
            },

            fn_goBack: function(){
                this.backButtonPress = true;
                this.$router.go(-1);
            }
        },
        mounted: function(){


            setTimeout(() => {
                if(this.$root.dialogLoader && !this.loading && this.getDataCounter >= 5){
                    this.cacheRetry = true;
                }
            }, 1 * 30 * 1000);
            // !this.$root.CurrentBusiness.DataDrive ? this.fn_checkTransactionCount() : '';

            this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat();
            this.fn_addOns();

            // if(this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
            //     for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
            //         let field = this.$root.TransactionSettings.batchFields[i]
            //         if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
            //             this.hasSeries = true;
            //         }

            //         if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
            //             this.hasOnlySeries = false;
            //         }
            //     }
            // }

            // if(!this.Form.selectedBatchType){
            //     this.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
            // }

            if(this.$route.query && this.$route.query.tagId){//in case of new form
                this.formId = this.$route.query.tagId;
                this.draftStorageId = 'draft_transaction_'+this.formId;
                // this.dialogStorageId = 'dialog_'+this.formId;
            }
            else if(this.$route.params && this.$route.params.tagId){//in case of edit form
                this.formId = this.$route.params.tagId;
                this.draftStorageId = 'draft_transaction_'+this.formId;
                // this.dialogStorageId = 'dialog_'+this.formId;
            }

            if(localStorage.getItem(this.draftStorageId)){
                let dataObj = JSON.parse(localStorage.getItem(this.draftStorageId));
                this.Form = JSON.parse(dataObj.formData);
            }

            setTimeout(() => {
                this.fn_setNewItem();
            }, 300);

            this.$refs['ref_dialogForm'].openDialogWeb();

            this.seriesFields = [];
			if(this.$root.TransactionSettings.enableBatch && this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
				for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
					let field = this.$root.TransactionSettings.batchFields[i]
					if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
						this.hasSeries = true;
						this.seriesFields.push(field);
					}

					if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
						this.hasOnlySeries = false;
					}
				}

				// if(!this.Form.selectedBatchType){
                this.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
                this.Form.finishedGoodBatchType = !this.hasOnlySeries ? 1 : 2;
				// }
			}

        },
        beforeRouteEnter (to, from, next) {
            next(vm => {

                let itemId = null;

                //edit from display view 
                if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
                    itemId = from.params.tagId;
                    vm.fn_getData(itemId);
                }
                else{
                    vm.fn_getNumberSeries();
                }

            })
        },
        computed:{
            // totalAmount: function(){
            //     let rate = this.Form.rate ? this.Form.rate : 0;
            //     return this.roundUpto2Decimals(rate * this.Form.qty);
            // }
            totalAmount: function(){
                let addontotal = 0;
                for(let i=0; i<this.Form.transactionAddOns.length; i++){
                    let value = this.Form.transactionAddOns[i].value ? Number(this.Form.transactionAddOns[i].value) : 0;
                    addontotal = value + addontotal;
                }

                let amount = this.Form.amount ? Number(this.Form.amount) : 0;
                return amount + Number(addontotal);
            }
        }
    }

</script>